import React, { useState } from "react";
import { Link } from "react-router-dom";

import instituteData from "../Institute/InstituteData";
import styled from "styled-components";

const Wrapper = styled.section`
  .navbarTab .tabs h4 {
    padding-bottom: 10px;
    border-bottom: 1px solid #bbbbbb;
  }

  .nav-link-tab {
    // font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
    text-decoration: none;
    color: #031d44;
    padding: 20px 0px;
    margin: 0px 20px;
    display: inline-block;
    position: relative;
    opacity: 0.75;
  }

  .nav-link-tab:hover {
    opacity: 1;
  }

  .nav-link-tab::before {
    transition: 300ms;
    height: 2px;
    content: "";
    position: absolute;
    background-color: #134694;
  }

  .nav-link-tab-fade-up::before {
    width: 100%;
    bottom: 5px;
    opacity: 0;
  }

  .nav-link-tab-fade-up:hover::before {
    bottom: 10px;
    opacity: 1;
  }
  .navbarTab ul {
    list-style: none;
    padding: 0px 0px;
  }
  .navbarTab ul li {
    padding: 5px 0;
  }
  .navbarTab ul li a{
    text-decoration:none;
  }
`;

const InstituteCat = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabHover = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <Wrapper>
      <div className="navbarTab">
        <div className="navbarTabHead1 mb-2">
          <div
            className="nav-link-tab nav-link-tab-fade-up tab"
            onMouseEnter={() => handleTabHover("tab1")}
          >
            ISRDC
          </div>
          <div
            className="nav-link-tab nav-link-tab-fade-up tab"
            onMouseEnter={() => handleTabHover("tab2")}
          >
            RC
          </div>
          <div
            className="nav-link-tab nav-link-tab-fade-up tab"
            onMouseEnter={() => handleTabHover("tab3")}
          >
            PI-I
          </div>
          <div
            className="nav-link-tab nav-link-tab-fade-up tab"
            onMouseEnter={() => handleTabHover("tab4")}
          >
            PI-II
          </div>
        </div>
        {activeTab === "tab1" && (
          <div className="tabs">
            <h4>INFORMATION SECURITY RESEARCH AND DEVELOPMENT CENTRES</h4>

            <ul>
              {instituteData
                .filter((item) => item.code === "isrdc")
                .map((item) => (
                  <li key={item.id}>
                    <Link to={`/institute/${item.code}/${item.id}`}>
                      {item.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        )}
        {activeTab === "tab2" && (
          <div className="tabs">
            <h4>RESOURCE CENTERS</h4>

            <ul>
              {instituteData
                .filter((item) => item.code === "rc")
                .map((item) => (
                  <li key={item.id}>
                    <Link to={`/institute/${item.code}/${item.id}`}>
                      {item.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        )}
        {activeTab === "tab3" && (
          <div className="tabs">
            <h4>PARTICIPATING INSTITUTES - I</h4>

            <ul>
              {instituteData
                .filter((item) => item.code === "PI-I")
                .map((item) => (
                  <li key={item.id}>
                    <Link to={`/institute/${item.code}/${item.id}`}>
                      {item.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        )}
        {activeTab === "tab4" && (
          <div className="tabs">
            <h4>PARTICIPATING INSTITUTES - II</h4>
            <ul>
              <li>Centre for Development of Advanced Computing, Bangalore</li>
              <li>Centre for Development of Advanced Computing, Hyderabad</li>
              <li>Centre for Development of Advanced Computing, Kolkata</li>
              <li>Centre for Development of Advanced Computing, Mohali</li>
              <li>Centre for Development of Advanced Computing, Noida</li>
              <li>
                Centre for Development of Advanced Computing, Thiruvananthapuram
              </li>
              <li>
                National Institute for Electronics and Information Technology
                Chennai
              </li>
            </ul>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default InstituteCat;
